const onBehalfErrorSelector = (params: string) => {
  if (params.includes('onbehalfreturnstatus=1')) return 'userError';
  if (params.includes('onbehalfreturnstatus=2')) return 'userNotAllowed';
  if (params.includes('onbehalfreturnstatus=3')) return 'technicalError';

  window.location.replace(`${process.env.REACT_APP_FRONTPAGE_URL}`);
};

export default onBehalfErrorSelector;
